import React from "react";

import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Alert from "react-bootstrap/Alert";

import { Link } from "react-router-dom";

import { Mutation } from '@apollo/client/react/components';
import gql from "graphql-tag";

import "../styles/Login.css";

import { setToken, setUserData } from "../sessionStorage";

import KVALogoWide from "./KVALogoWide";
import LoadingView from "./LoadingView";
import ErrorView from "./ErrorView";
import OpenSource from "./OpenSource";

const SIGN_IN = gql`
  mutation SigninAccount($email: String!, $password: String!) {
    signinAccount(email: { email: $email, password: $password }) {
      token
      client_number
      account {
        firstName
        fullName
      }
    }
  }
`;

interface ILoginProps {
  loginCustomer: any;
  history: any;
}

export default class Login extends React.Component<ILoginProps> {
  state: {
    email: string;
    password: string;
  };

  constructor(props: any) {
    super(props);

    this.state = {
      email: "",
      password: "",
    };

    this.handleLogin = this.handleLogin.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEmail = this.handleEmail.bind(this);
    this.handlePassword = this.handlePassword.bind(this);
  }

  handleEmail(event: any) {
    this.setState({ ...this.state, email: event.target.value });
  }

  handlePassword(event: any) {
    this.setState({ ...this.state, password: event.target.value });
  }

  handleSubmit(event: any, sign_in: any) {
    event.preventDefault();

    sign_in({
      variables: {
        email: this.state.email,
        password: this.state.password,
      },
    });
  }

  handleLogin(token: string, userData: any) {
    setToken(token);
    setUserData({
      firstNames: userData.account.firstName,
      fullName: userData.account.fullName,
      clientNumber: userData.client_number,
    });

    this.props.loginCustomer();
    this.props.history.replace("/");
  }

  validateForm() {
    return this.state.password.length >= 10 && this.state.email.length >= 5;
  }

  render() {
    return (
      <>
        <Mutation
          mutation={SIGN_IN}
          onCompleted={(data: any) =>
            this.handleLogin(data.signinAccount.token, data.signinAccount)
          }
        >
          {(sign_in: any, { loading, error, data }: any) => {
            if (loading) {
              return <LoadingView />;
            }
            if (error) {
              if (error.networkError != null) {
                return <ErrorView error={error} />;
              }
            }

            const errMsg = (
              <Alert variant={"danger"}>
                Ungültige E-Mail/Passwort-Kombination
              </Alert>
            );

            return (
              <>
                <div id="big-wrapper">
                  <Container fluid>
                    <div className="depth1">
                      <Row>
                        <Col xs={12} md={4} lg={3} className="fully bg-blue" />
                        <Col xs={12} md={8} lg={9} className="bg-img" />
                      </Row>
                    </div>
                    <div className="depth2">
                      <Container fluid>
                        <Row>
                          <Col xs={2} md={6} lg={6} />
                          <Col xs={10} md={6} lg={6}>
                            <div className="p-4">
                              <KVALogoWide />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            xs={12}
                            md={{ span: 6, offset: 3 }}
                            lg={{ span: 4, offset: 2 }}
                          >
                            <div className="form-wrapper brt-3 brb-3">
                              <h2 className="underline p-4">
                                Anmeldung / Login
                              </h2>
                              <form
                                className="new_account px-4 pb-4"
                                id="new_account"
                                acceptCharset="UTF-8"
                                onSubmit={(event) =>
                                  this.handleSubmit(event, sign_in)
                                }
                              >
                                <div className="form-group">
                                  <div className="form-group email required account_email">
                                    <label
                                      className="control-label email required"
                                      htmlFor="account_email"
                                    >
                                      E-Mail Adresse
                                    </label>
                                    <input
                                      className="form-control string email required form-control"
                                      placeholder="E-Mail Adresse"
                                      type="email"
                                      value={this.state.email}
                                      onChange={this.handleEmail}
                                    />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <div className="form-group password required account_password">
                                    <label
                                      className="control-label password required"
                                      htmlFor="account_password"
                                    >
                                      Passwort
                                    </label>
                                    <input
                                      className="form-control password required form-control"
                                      placeholder="Passwort"
                                      type="password"
                                      value={this.state.password}
                                      onChange={this.handlePassword}
                                    />
                                  </div>
                                </div>

                                {error ? errMsg : ""}

                                <div className="row">
                                  <div className="col">
                                    <input
                                      type="submit"
                                      className="btn btn-primary"
                                      name="commit"
                                      value="Einloggen"
                                      disabled={!this.validateForm()}
                                    />
                                  </div>
                                  <div className="col psw text-right">
                                    <Link to="/passwort">
                                      Passwort vergessen?
                                    </Link>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </Col>
                        </Row>
                      </Container>
                    </div>
                  </Container>
                </div>
              </>
            );
          }}
        </Mutation>
        <OpenSource extern={true} />
      </>
    );
  }
}
